import { memo } from 'react';
import TemplateCard from './template-card';

type Props = {
    itemId: string;
    index: number;
}

export default function BulkTemplateDialogRow({
    itemId,
    index,
}: Props) {
    return (
        <div className="mb-4">
            <TemplateCard templateId={itemId} index={index} />
        </div>
    );
}